import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { GetUserLanguageUseCase } from "@karma-games/angular-devkit/src/lib/modules/settings";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class GetGameRulesUseCase implements IUseCase<void, Promise<string>> {
    constructor(private http: HttpClient,
                private getUserLanguageUseCase: GetUserLanguageUseCase) {
    }

    async execute(): Promise<string> {
        const lang = await firstValueFrom(this.getUserLanguageUseCase.execute());
        return await firstValueFrom(this.http.get(`assets/game-rules/game-rules_${lang}.html`, { responseType: "text" }));
    }
}
